// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cuzdan {
  background: var(--color-first);
  padding: 2% 5%;
  border-radius: 5px;
  margin-right: 0;
  text-align: center;
  width: 15cqw;
  cursor: pointer;
  color: var(--color-white);
  font-size: 1cqw;
  border: 1px solid var(--color-first);
}

.choose-network {
  display: inline-flex;
  align-items: center;
  gap: 5%;
  background-color: var(--color-first);
  width: 2.25cqw;
  transition-duration: 0.5s;
  border-radius: 20%;
}
.choose-network img {
  padding: 15%;
}
.choose-network:hover {
  background-color: var(--color-third);
}

.cuzdan:hover {
  background-color: var(--color-third);
}
.cuzdan img {
  margin-right: 3%;
  width: 1.75cqw;
}
.cuzdan span {
  color: #fff;
}
.cuzdan-dropdown {
  margin: 0 3%;
}

.cuzdan-dropdown-content {
  position: absolute;
  width: 15cqw;
  border-left: 1px solid var(--color-first);
  border-bottom: 1px solid var(--color-first);
  border-right: 1px solid var(--color-first);
  background-color: #f6efe3;
  padding: 2px 6px;
  display: none;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  border-radius: 0 0 6px 6px;
}

.cuzdan-dropdown-content p {
  margin: 5px 0;
  padding: 0;
}

.cuzdan-dropdown:hover .cuzdan-dropdown-content {
  display: block;
}

.cuzdan-dropdown:hover .cuzdan {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
@media (max-width: 760px) {
  .cuzdan {
    width: 25cqw;
    font-size: 2cqw;
    padding: 4%;
  }
  .cuzdan-dropdown-content {
    width: 30cqw;
  }
  .cuzdan img {
    width: 3.75cqw;
  }
  .cuzdan-dropdown {
    margin: 0;
  }
  
  .choose-network {
    width: 5cqw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/connect-button/ConnectButton.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,OAAO;EACP,oCAAoC;EACpC,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE;IACE,YAAY;IACZ,eAAe;IACf,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".cuzdan {\n  background: var(--color-first);\n  padding: 2% 5%;\n  border-radius: 5px;\n  margin-right: 0;\n  text-align: center;\n  width: 15cqw;\n  cursor: pointer;\n  color: var(--color-white);\n  font-size: 1cqw;\n  border: 1px solid var(--color-first);\n}\n\n.choose-network {\n  display: inline-flex;\n  align-items: center;\n  gap: 5%;\n  background-color: var(--color-first);\n  width: 2.25cqw;\n  transition-duration: 0.5s;\n  border-radius: 20%;\n}\n.choose-network img {\n  padding: 15%;\n}\n.choose-network:hover {\n  background-color: var(--color-third);\n}\n\n.cuzdan:hover {\n  background-color: var(--color-third);\n}\n.cuzdan img {\n  margin-right: 3%;\n  width: 1.75cqw;\n}\n.cuzdan span {\n  color: #fff;\n}\n.cuzdan-dropdown {\n  margin: 0 3%;\n}\n\n.cuzdan-dropdown-content {\n  position: absolute;\n  width: 15cqw;\n  border-left: 1px solid var(--color-first);\n  border-bottom: 1px solid var(--color-first);\n  border-right: 1px solid var(--color-first);\n  background-color: #f6efe3;\n  padding: 2px 6px;\n  display: none;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  border-radius: 0 0 6px 6px;\n}\n\n.cuzdan-dropdown-content p {\n  margin: 5px 0;\n  padding: 0;\n}\n\n.cuzdan-dropdown:hover .cuzdan-dropdown-content {\n  display: block;\n}\n\n.cuzdan-dropdown:hover .cuzdan {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n@media (max-width: 760px) {\n  .cuzdan {\n    width: 25cqw;\n    font-size: 2cqw;\n    padding: 4%;\n  }\n  .cuzdan-dropdown-content {\n    width: 30cqw;\n  }\n  .cuzdan img {\n    width: 3.75cqw;\n  }\n  .cuzdan-dropdown {\n    margin: 0;\n  }\n  \n  .choose-network {\n    width: 5cqw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
